document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.melaxin').forEach(initMelaxin);
});

function initMelaxin(root) {
  initLightbox(root);
  initGallery(root);
  initMiniTimer(root);
}

function initLightbox(root) {
  var box = root.querySelector('[data-lightbox]');
  if (!box) return;
  var imgs = Array.prototype.slice.call(root.querySelectorAll('.melaxin__gallery-img'));
  var img = box.querySelector('[data-lightbox-img]');
  var idx = 0;

  function show(i) {
    idx = (i + imgs.length) % imgs.length;
    img.src = imgs[idx].currentSrc || imgs[idx].src;
    img.alt = imgs[idx].alt || '';
  }
  function open(i) { show(i); box.hidden = false; document.body.style.overflow = 'hidden'; }
  function close() { box.hidden = true; document.body.style.overflow = ''; }

  root.querySelectorAll('[data-lightbox-open]').forEach(function (btn, i) {
    btn.addEventListener('click', function () { open(i); });
  });
  box.querySelector('[data-lightbox-close]').addEventListener('click', close);
  box.querySelector('[data-lightbox-prev]').addEventListener('click', function () { show(idx - 1); });
  box.querySelector('[data-lightbox-next]').addEventListener('click', function () { show(idx + 1); });
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') show(idx - 1);
    if (e.key === 'ArrowRight') show(idx + 1);
  });
}

function initGallery(root) {
  var track = root.querySelector('[data-gallery-track]');
  var dotsWrap = root.querySelector('[data-gallery-dots]');
  if (!track || !dotsWrap) return;
  var slides = Array.prototype.slice.call(track.children);
  if (!slides.length) return;
  slides.forEach(function (_, i) {
    var d = document.createElement('span');
    if (i === 0) d.className = 'active';
    dotsWrap.appendChild(d);
  });
  var dots = Array.prototype.slice.call(dotsWrap.children);
  function updateActive() {
    var scrollLeft = track.scrollLeft;
    var width = track.clientWidth;
    var i = Math.round(scrollLeft / width);
    dots.forEach(function (d, idx) { d.className = idx === i ? 'active' : ''; });
  }
  track.addEventListener('scroll', function () {
    clearTimeout(track._t);
    track._t = setTimeout(updateActive, 80);
  }, { passive: true });
}

function initMiniTimer(root) {
  var el = root.querySelector('[data-mini-timer]');
  if (!el) return;
  function msUntilMidnight() {
    var now = new Date();
    var next = new Date(now);
    next.setHours(24, 0, 0, 0);
    return next - now;
  }
  function render() {
    var ms = msUntilMidnight();
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    el.textContent = (h > 0 ? String(h).padStart(2, '0') + ':' : '') + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }
  render();
  setInterval(render, 1000);
}
